import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerComponent } from './shared/components/toast/toast-container.component';
import { ChunkErrorHandlerService } from '@core/services/chunk-error-handler.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, ToastContainerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'console';

    private chunkErrorHandler = inject(ChunkErrorHandlerService);

    constructor() {
        this.chunkErrorHandler.init();
    }
}
